import { Component, State, Prop, h, Element } from '@stencil/core';
import { FormGroup, DefaultValidations } from '../../helpers/forms';
import { downloadScript } from '../../helpers/loader';
import "../../ionic/ionic.module";
import { modalController, alertController } from '@ionic/core';
import { FUNCTIONS_URL } from '../../firebase/firebaseConsts';
import { environment } from '../../environments/environment';
import { callFirebaseCloudFunction } from '../../firebase/firebaseFunctions';

// const development = !environment.production
// const DB_URL = development ? `http://localhost:8000` : 'https://pager-online.fly.dev'

@Component({
  tag: 'line-signup',
  styleUrl: 'line-signup.css',
  shadow: false
})
export class LineSignup {
  auxState: boolean;
  @State() auxState2: boolean;
  @State() formValid: boolean = false;
  @State() isLoading: boolean = false;

  @State() signupSucess: boolean = false;
  @State() signupFail: boolean = false;
  @State() signupError = '';
  @State() emailAlreadyExists = false;

  @Prop() inApp: boolean = false;
  @Prop() from: string;

  validations = DefaultValidations;
  signupForm: FormGroup = new FormGroup({
    name: {
      validation: (field, val) => [
        this.validations.isRequired(field, val),
        this.validations.minWidth(field, val, 4),
        this.validations.maxWidth(field, val, 60)
      ].filter(val => !(!(val)))
    },
    firmName: {
      validation: (field, val) => [
        this.validations.isRequired(field, val),
        this.validations.minWidth(field, val, 4),
        this.validations.maxWidth(field, val, 60)
      ].filter(val => !(!(val)))
    },
    ddd: {
      validation: (field, val) => [
        this.validations.maxWidth(field, val, 2)
      ].filter(val => !(!(val)))
    },
    phone: {
      validation: (field, val) => [
        this.validations.isRequired(field, val),
        // this.validations.minWidth(field, val, 8),
        this.validations.maxWidth(field, val, 20)
      ].filter(val => !(!(val)))
    },
    email: {
      validation: (field, val) => [
        this.validations.isRequired(field, val),
        this.validations.minWidth(field, val, 10),
        this.validations.maxWidth(field, val, 60),
        this.validations.isEmail(field, val),
      ].filter(val => !(!(val)))
    },
    password: {
      validation: (field, val) => [
        this.validations.isRequired(field, val),
        this.validations.minWidth(field, val, 6),
        this.validations.maxWidth(field, val, 40)
      ].filter(val => !(!(val)))
    },
    confPassword: {
      validation: (field, val) => [
        this.validations.isRequired(field, val),
        this.validations.minWidth(field, val, 6),
        this.validations.maxWidth(field, val, 40),
      ].filter(val => !(!(val)))
    },
  }, [this.validations.confirmPass]);

  handleNameChange(e) {
    this.handleFormChanges('name', this.validations.sanitizeName('name', e));
  }

  handleFirmNameChange(e) {
    this.handleFormChanges('firmName', this.validations.sanitizeName('firmName', e));
  }

  handlePhoneChange(e) {
    this.handleFormChanges('phone', this.validations.sanitizePhone('phone', e));
  }

  handleDDDChange(e) {
    this.handleFormChanges('ddd', this.validations.sanitizePhone('ddd', e));
  }

  handleEmailChange(e) {
    this.handleFormChanges('email', this.validations.sanitizeEmail('email', e));
  }

  handlePassChange(e) {
    this.handleFormChanges('password', this.validations.sanitizePass('password', e));
  }

  handlePassConfChange(e) {
    this.handleFormChanges('confPassword', this.validations.sanitizePass('confPassword', e));
  }

  validateForm() {
    this.auxState2 = !this.auxState2;
    this.formValid = this.signupForm.valid();
  }

  handleFormChanges(field, value) {
    this.signupForm.updateField(field, value);
    environment.production || console.log(this.signupForm.valid(), this.signupForm.fields);
    this.validateForm();
  }

  inputTouched(field) {
    // const prev = this.signupForm.fields[field].touched;
    this.signupForm.fields[field].touched = true;
    this.validateForm();
  }

  handleSubmit(e) {
    e.preventDefault();
    let formValue: any;
    if (this.formValid) {
      formValue = this.signupForm.value();
    } else {
      // console.log('invalid', Object.values(this.signupForm.fields)
      //   .filter(val => (val.errors && (val.errors.length > 0)))
      //   .map(val => {
      //     return { [val.name]: val.errors }
      //   })
      // );
      return;
    }

    if (formValue && Object.values(formValue).length > 0) {
      const verif = this.isVerified();
      if (verif) {
        const urlParams = new URLSearchParams(window.location.search);
        const from = this.from ?? urlParams.get('from') ?? window.location.href ?? null;
        formValue = { ...formValue, verif, from };
        environment.production || console.log(formValue);
        this.postSignup(formValue);
      }
    }
  }

  async postSignup(form) {
    console.log({ form })
    this.isLoading = true;
    try {
      try {
        const result = await fetch(
          `${FUNCTIONS_URL}/signupRequest`,
          {
            method: 'POST',
            body: JSON.stringify({
              ...form,
            }),
            headers: {
              'Content-Type': 'application/json'
            },
          });
        this.handlePostResponse(result);
      } catch (err) {
        console.error(err);
      }
    } finally {
      this.isLoading = false;
    }
  }

  async passwordReset(email: string): Promise<boolean> {
    const res = await callFirebaseCloudFunction('recoverPasswordRequest', { user: email })
    if (res.response.status === 200) {
      const alert = await alertController.create({
        header: 'E-mail enviado',
        message: 'Você receberá um e-mail para trocar a senha. Verifique sua caixa de entrada.',
        buttons: ['OK'],
      });
      await alert.present();
      return true;
    } else {
      const alert = await alertController.create({
        header: 'Erro',
        message: 'Não foi possível recuperar a senha. Entre em contato com o suporte.',
        buttons: ['OK'],
      });
      await alert.present();
      return false;
    }
  }

  async promptPasswordReset() {
    const formEmail = this.signupForm.fields.email?.value?.trim();
    const alert = await alertController.create({
      // cssClass: 'my-custom-class',
      header: 'Recuperar senha',
      // subHeader: 'Este E-mail já foi cadastrado',
      message: 'Preencha seu e-mail abaixo e clique no botão em "Recuperar Senha". Em seguida, verifique a caixa de entrada do seu e-mail.',
      inputs: [{ type: 'email', name: 'email', label: 'E-mail', value: formEmail ?? '', placeholder: 'E-mail' }],
      buttons: [
        { text: 'Cancelar', role: 'cancel', cssClass: 'secondary', },
        { text: 'Recuperar Senha', role: 'confirm' }
      ],
    });

    await alert.present();

    const { role, data } = await alert.onDidDismiss();
    if (role === 'confirm') {
      const email = data?.values?.email;
      console.log('data', data);
      const passwordResetSuccess = await this.passwordReset(email);
      if (passwordResetSuccess) {
        await this.presentAlertRecuperarSenhaSuccess();
      }
    }
  }

  async handlePostResponse(res: Response) {
    // console.log(`${res.status} ${res.statusText}`, res.body);
    try {
      window['grecaptcha']?.reset();
    } catch { }
    console.log({ res })
    this.signupSucess = res.ok;
    this.signupFail = !res.ok;
    if (this.signupFail) {
      this.handlePostError(res);
    } else {
      if (this.signupSucess) {
        // this.gtag_report_conversion(window.location.href);
        (window as any).gtag_report_conversion?.();
      }
      const resData = await res.json() ?? {}
      // console.log(resData)
      const params = resData.session
        ? `#access_token=${resData.session}`
        : ''
      const link = environment.production ? `https://pager-online.web.app/login${params}` : `http://localhost:5173/login${params}`;
      setTimeout(() => {
        // console.log(link)
        window.location.href = link;
      }, 1000);
    }
  }

  async presentModal(component, cssClass) {
    const modal = await modalController.create({
      component,
      cssClass,
    });
    await modal.present();
  }
  async presentAlertRecuperarSenha() {
    const alert = await alertController.create({
      // cssClass: 'my-custom-class',
      header: 'E-mail já cadastrado',
      // subHeader: 'Este E-mail já foi cadastrado',
      message: 'Deseja receber um e-mail de recuperação de senha?',
      buttons: [
        { text: 'Cancelar', role: 'cancel', cssClass: 'secondary', },
        { text: 'Recuperar Senha', role: 'confirm', cssClass: 'success', }
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    if (role === 'confirm') {
      const email = this.signupForm.fields.email?.value;
      const passwordResetSuccess = await this.passwordReset(email);
      if (passwordResetSuccess) {
        await this.presentAlertRecuperarSenhaSuccess();
      }
    }
  }
  async presentAlertRecuperarSenhaSuccess() {
    const alert = await alertController.create({
      // cssClass: 'my-custom-class',
      header: 'Verifique seu e-mail',
      // subHeader: 'E-mail já cadastrado',
      message: 'Foi enviado um e-mail de recuperação de senha. Abra seu aplicativo de e-mail e clique no link para criar uma nova senha',
      buttons: ['OK'],
    });
    await alert.present();
  }

  async handlePostError(res: Response) {
    const err = await res.text();
    console.error(err);
    if (res?.status === 409) {
      this.signupError = 'Este e-mail já foi cadastrado.';
      this.emailAlreadyExists = true;
      await this.presentAlertRecuperarSenha();
      throw err;
    }
    this.emailAlreadyExists = false;
    this.signupError = err;
  }

  handlePhoneKeypress(e) {
    if (isNaN(Number(e.key))) {
      e.preventDefault();
    }
  }

  isVerified() {
    if (window['grecaptcha'] && window['grecaptcha'].getResponse) {
      const result = window['grecaptcha'].getResponse();
      // console.log('captcha', result);
      this.auxState = !this.auxState;
      return result;
    } else {
      this.auxState = !this.auxState;
      return false;
    }
  }

  componentDidLoad() {
    this.prepareCaptcha();
  }

  prepareCaptcha() {
    window['onCaptchaReady'] = (e) => {
      // console.log('onCaptchaReady');
      // window['grecaptcha'].render(
      //   this.captchaRef,
      //   { "sitekey": "6LffRHoUAAAAAAf17UiroRcbsH7m-ZIyGFSg1lHN" },
      // );
    };
    downloadScript('https://www.google.com/recaptcha/api.js');
    // const scriptTag = document.createElement('script');
    // scriptTag.src = 'https://www.google.com/recaptcha/api.js';//?onload=onCaptchaReady&render=explicit

    // // scriptTag.onload = implementationCode;
    // // scriptTag.onreadystatechange = implementationCode;

    // document.head.appendChild(scriptTag);
  }

  async googleLogin() {
    const {response, data} = await callFirebaseCloudFunction<{url}, undefined>('googleLoginRequest', undefined, { cache: 'no-cache', },);
    if (response.ok) {
      window.location.href = data.url;
    } else {
      console.error(`${response.status}-${response.statusText}`);
      console.error(`${data}`);
    }
  }

  closeWindow() {
    window.close();
  }


  renderErrors(fieldName) {
    const field = this.signupForm.fields[fieldName];
    // console.log(field);
    if (field?.touched && field?.errors?.length) {
      return (
        <ion-note slot="none ion-padding" class="input-message" color="danger">
          {field.errors[0]}
        </ion-note>
      );
    } else {
      return (
        <ion-note slot="none ion-padding" class="input-message invisible" color="danger">
          .
        </ion-note>
      );
    }
  }

  renderFinalize() {
    let icon;
    if (this.isLoading) {
      icon = <ion-spinner slot="start"></ion-spinner>;
    } else {
      icon = <ion-icon slot="start" name="person-add"></ion-icon>;
    }
    // const gtag_report_conversion = (window as any).gtag_report_conversion;

    return (
      <ion-col class="ion-no-padding ion-align-items-center">
        <ion-row class="ion-justify-content-center">
          <ion-button color="secondary" margin-horizontal class="finalize-button ion-margin" type="submit" disabled={!(this.formValid)}>
            {icon}
            <ion-label slot="start" class="ion-margin-start">
              Registrar
            </ion-label>
          </ion-button>
        </ion-row>
        <ion-row class="ion-justify-content-center">
          OU
        </ion-row>
        <ion-row class="ion-justify-content-center">
          <ion-button color="white" margin-horizontal class="finalize-button ion-margin" onClick={this.googleLogin}>
            <ion-icon slot="start" src="assets/svg/google-logo.svg"></ion-icon>
            <ion-label slot="start" class="ion-margin-start">
              Entrar com Google
            </ion-label>
          </ion-button>
        </ion-row>
      </ion-col>
    )
  }
  renderFooter() {
    return (
      <ion-grid>
        <ion-row class="ion-justify-content-center">
          <ion-button color="dark" fill="clear" class="ion-margin-bottom" onClick={() => this.promptPasswordReset()}>
            <ion-label slot="start">
              Esqueci Minha Senha
            </ion-label>
          </ion-button>
        </ion-row>
      </ion-grid>
    )
  }

  renderPostError() {
    if (this.signupFail) {
      return (
        <ion-grid>
          <ion-row><div class="post-error">Ocorreu um erro ao realizar o registro:</div></ion-row>
          {this.signupError && <ion-row><div class="post-error">{this.signupError}</div></ion-row>}
        </ion-grid>
      );
    }
  }

  renderPostSuccess() {
    let button;
    if (this.inApp) {
      button =
        <ion-button onClick={() => this.closeWindow()}>
          <ion-icon name="arrow-back" slot="start"></ion-icon>
          <ion-label slot="start">
            Voltar ao Sistema
          </ion-label>
        </ion-button>
        ;
    } else {
      button =
        <a href="https://pager-online.web.app">
          <ion-button>
            <ion-icon name="logo-google-playstore" slot="start"></ion-icon>
            <ion-label slot="start">
              Acesse o Sistema
            </ion-label>
          </ion-button>
        </a>
        ;
    }

    return (
      <div class="post-success">
        <ion-icon class="post-success-icon" name="checkmark"></ion-icon>
        <div class="post-success-message"> Registrado com sucesso! </div>
        {button}
      </div>
    )
  }

  renderDefault() {
    return [
      <form onSubmit={e => this.handleSubmit(e)}>
        <div class="line-signup-container">

          <div class="field-container field-container-50">
            <ion-item class="input-item" lines="none">
              <ion-label position="floating">Nome do Estabelecimento</ion-label>
              <ion-input type="text" maxlength={60} onIonInput={e => this.handleFirmNameChange(e.target['value'])} onIonBlur={e => this.inputTouched('firmName')}></ion-input>
            </ion-item>
            {this.renderErrors('firmName')}
          </div>


          <div class="field-container field-container-50">
            <ion-item class="input-item" lines="none">
              <ion-label position="floating">Nome para contato</ion-label>
              <ion-input type="text" maxlength={60} onIonInput={e => this.handleNameChange(e.target['value'])} onIonBlur={e => this.inputTouched('name')}></ion-input>
            </ion-item>
            {this.renderErrors('name')}
          </div>

          <div class="field-container field-container-50 field-container-dddphone">
            <div class="field-container field-container-ddd">
              <ion-item class="input-item" lines="none">
                <ion-label position="floating">DDD</ion-label>
                <ion-input type="tel" pattern="[0-9]*" maxlength={2} onIonInput={e => this.handleDDDChange(e.target['value'])} onKeyPress={(e) => this.handlePhoneKeypress(e)} onIonBlur={e => this.inputTouched('ddd')}></ion-input>
              </ion-item>
              {this.renderErrors('ddd')}
            </div>

            <div class="field-container field-container-phone">
              <ion-item class="input-item" lines="none">
                <ion-label position="floating">Telefone</ion-label>
                <ion-input type="tel" pattern="[0-9]*" maxlength={15} onIonInput={e => this.handlePhoneChange(e.target['value'])} onKeyPress={(e) => this.handlePhoneKeypress(e)} onIonBlur={e => this.inputTouched('phone')}></ion-input>
              </ion-item>
              {this.renderErrors('phone')}
            </div>
          </div>

          <div class="field-container field-container-50">
            <ion-item class="input-item" lines="none">
              <ion-label position="floating">E-mail</ion-label>
              <ion-input type="email" maxlength={60} onIonInput={e => this.handleEmailChange(e.target['value'])} onIonBlur={e => this.inputTouched('email')}></ion-input>
            </ion-item>
            {this.renderErrors('email')}
          </div>

          <div class="field-container  field-container-50">
            <ion-item class="input-item" lines="none">
              <ion-label position="floating">Senha</ion-label>
              <ion-input type="password" maxlength={30} onIonInput={e => this.handlePassChange(e.target['value'])} onIonBlur={e => this.inputTouched('password')}></ion-input>
            </ion-item>
            {this.renderErrors('password')}
          </div>

          <div class="field-container  field-container-50">
            <ion-item class="input-item" lines="none">
              <ion-label position="floating">Confirme a senha</ion-label>
              <ion-input type="password" maxlength={30} onIonInput={e => this.handlePassConfChange(e.target['value'])} onIonBlur={e => this.inputTouched('confPassword')}></ion-input>
            </ion-item>
            {this.renderErrors('confPassword')}
          </div>
        </div>

        {this.renderPostError()}

        <div class="line-signup-finalize">

          <div id="verif" class="g-recaptcha" data-sitekey="6LfuCGspAAAAAD6Ppm02gnF5a6O9Ie5juAG0XqtB"></div>

          {this.renderFinalize()}

        </div>
        {this.renderFooter()}
      </form>
    ];
  }

  render() {
    if (this.signupSucess) {
      return this.renderPostSuccess();
    } else {
      return this.renderDefault();
    }
  }
}
